// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__Q2_Ss","button":"style_button__V7C58"};